import { Record as ImmutableRecord } from 'immutable'
import { AccountsAction, AccountsActions } from 'lib/actions/accounts'
import { initialCreateReturn, initialGetReturn } from 'lib/rpc'
import { ListAuthBackendsResponse, SignupResponse, Tenant } from 'pbts/c1/api/accounts/v1/accounts'

export class AccountsState extends ImmutableRecord({
    item: initialGetReturn<Tenant>(),
    signup: initialCreateReturn<SignupResponse>(),
    authbackends: initialGetReturn<ListAuthBackendsResponse>(),
}) {}

export const initialAccountsState: AccountsState = new AccountsState()

export const AccountsReducer = (state: AccountsState, action: AccountsActions): AccountsState => {
    switch (action.type) {
        case AccountsAction.get:
            return state.set('item', action.payload)
        case AccountsAction.signup:
            return state.set('signup', action.payload)
        case AccountsAction.authbackends:
            return state.set('authbackends', action.payload)
        // no default
    }
}
